@if (form && question()) {
  <p class="text-primary my-4 text-xl">{{ question().question }}</p>
  <form [formGroup]="form" (submit)="submit()">
    <div class="m-2 flex flex-col gap-6">
      @for (answer of shuffledAnswers(); track answer.name) {
        <label>
          <input
            type="checkbox"
            class="input checkbox checkbox-primary mr-2"
            [formControlName]="answer.name"
          />
          {{ answer.answer }}
        </label>
      }
    </div>
    <span class="text-sm text-gray-600">{{
      "instruction-details.quizz-question.one-or-more-hint" | translate
    }}</span>

    <br />
    <br />

    <button type="submit" class="btn btn-primary" [disabled]="form.invalid">
      {{ "common.confirm" | translate }}
    </button>
  </form>
}
